let content_blocks = require('../contents');

export function init(){
    
    $('#edit_video').find('.btn.btn-danger.delete_media').each(function(){
        $(this).on('click', function() {
            let modal = $(this).closest('.modal');
            let block_id = modal.find('[name="block_id"]').val();
            let block = $('#'+ block_id);
            let media_id = block.attr('data-preview-media-id');
            content_blocks.delete_media(media_id);
            block.attr('data-preview-media-id', '');
            block.attr('data-preview-src', '');
            block.attr('data-preview-name', '');
            modal.find('.row.preview').addClass('d-none');
        })
    });

    $('#edit_video_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_video_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="width"]').val(block.attr('data-width'));
        modal.find('[name="height"]').val(block.attr('data-height'));
        modal.find('[name="alt"]').val(block.attr('data-alt'));
        modal.find('[name="controls"]').prop('checked', block.attr('data-controls') == 'true' ? true : false);
        modal.find('[name="autoplay"]').prop('checked', block.attr('data-autoplay') == 'true' ? true : false);
        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="type"]').val(block.attr('data-type'));
        
        let select_align = modal.find('[name="align"]');
        select_align.find('option[value="'+ block.attr('data-align') +'"]').prop('selected', true);
        select_align.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
        
        let video = modal.find('input[name="video"]');
        let label_video = video.next('label');
        label_video.text(block.attr('data-name'));

        let preview = modal.find('input[name="preview"]');
        let label_preview = preview.next('label');
        label_preview.text(block.attr('data-preview-name'));

        let container_img_preview = modal.find('.row.preview');
        
        if (block.attr('data-preview-src') != '') {
            container_img_preview.removeClass('d-none');
            let img_preview = container_img_preview.find('img');
            img_preview.attr('src', block.attr('data-preview-src'));
        } else {
            container_img_preview.addClass('d-none');
        }
    });

    $('#edit_video').on('submit', function (e) {
        e.preventDefault();

        let block = $('#'+ $(this).find('[name="block_id"]').val());

        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        block.attr('data-width', $(this).find('[name="width"]').val());
        block.attr('data-height', $(this).find('[name="height"]').val());
        block.attr('data-alt', $(this).find('[name="alt"]').val());
        block.attr('data-align', $(this).find('[name="align"]').val());
        block.attr('data-controls', $(this).find('[name="controls"]').prop('checked'));
        block.attr('data-autoplay', $(this).find('[name="autoplay"]').prop('checked'));
        
        let modal = $(this).closest('.modal');
        modal.modal('hide');

        let form_data = new FormData($(this)[0]);
        if (form_data.get('video').name != '' || form_data.get('preview').name != '') {
            update_content_video(form_data, block);
        }

        content_blocks.change_visible_button_blocks(block);
        
        $(this)[0].reset();

    });

    $('.block[data-type="video"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })

    function update_content_video(form_data, block) {
        let url = window._routes['microsites.contents.media'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

        form_data.append('type', block.attr('data-type'));
        window.forms.post(url, form_data, true, true)
            .then((response) => {
                if (response.data != null) {
                    block.attr('data-src', response.data.src);
                    block.attr('data-name', response.data.name);
                    block.attr('data-media-id', response.data.media_id);
                    block.attr('data-preview-src', response.data.preview_src);
                    block.attr('data-preview-name', response.data.preview_name);
                    block.attr('data-preview-media-id', response.data.preview_media_id);

                    let card_body = block.find('.card-body');
                    card_body.removeClass();
                    card_body.addClass(['card-body', 'd-flex','justify-content-'+form_data.get('align')]);
                    block.find('video').attr('src', response.data.src);
                }
                                
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
            });
    }
}